import React from 'react';
import styled from 'styled-components';
import Image from './Image';
import Label from './Label';
import Select, { SelectHeaderSize } from './Select';
import { DefaultChildrenWrapper } from './Popover';
const ArrowLeft = require('../assets/images/ui_arrow_left_gray.svg');
const ArrowRight = require('../assets/images/ui_arrow_right_gray.svg');
export default class PaginationComponent extends React.Component {
    constructor(props) {
        super(props);
        this.getSafePage = (page) => {
            if (Number.isNaN(page)) {
                page = this.props.page;
            }
            return Math.min(Math.max(page, 0), this.props.pages - 1);
        };
        this.changePage = (page) => {
            page = this.getSafePage(page);
            this.setState({ page });
            if (this.props.page !== page) {
                this.props.onPageChange(page);
            }
        };
        this.buildSelectElements = (pageSizeOptions) => {
            const groupBySelectElements = [];
            pageSizeOptions.map(pageSize => {
                groupBySelectElements.push({
                    value: pageSize,
                    displayValue: `${pageSize} ${this.props.rowsText}`,
                    disabled: false,
                });
            });
            return groupBySelectElements;
        };
        this.buildSelectedElement = (pageSize) => {
            return {
                value: pageSize,
                displayValue: `${pageSize} ${this.props.rowsText}`,
                disabled: false,
            };
        };
        this.onGroupByChange = (element) => {
            this.props.onPageSizeChange(element.value);
        };
        this.state = {
            page: props.page
        };
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ page: nextProps.page });
    }
    render() {
        const { 
        // Props
        data, page, pageSizeOptions, pageSize, canPrevious, canNext, isServerSidePagination = false, } = this.props;
        const shouldRenderPreviousButton = !isServerSidePagination || (page && page > 0);
        const previousPageButton = shouldRenderPreviousButton ? (React.createElement(PaginationButton, { src: ArrowLeft, alt: 'Previous', isDisabled: !isServerSidePagination ? !canPrevious : (!page || page === 0), onClick: () => {
                if ((!isServerSidePagination && !canPrevious) || (isServerSidePagination && (!page || page === 0)))
                    return;
                this.changePage(page - 1);
            }, "data-testid": 'paginationComponent_paginationButton' })) : null;
        const shouldRenderNextButton = !isServerSidePagination || (data && data.length === pageSize);
        const nextPageButton = shouldRenderNextButton ? (React.createElement(PaginationButton, { src: ArrowRight, alt: 'Next', isDisabled: !isServerSidePagination ? !canNext : (!data || data.length < pageSize), onClick: () => {
                if ((!isServerSidePagination && !canNext) || (isServerSidePagination && (!data || data.length < pageSize)))
                    return;
                this.changePage(page + 1);
            } })) : null;
        return (React.createElement(PaginationWrapper, { style: this.props.style },
            React.createElement(PaginationLabel, { text: this.props.pageText }),
            React.createElement(PaginationSelect, { selectHeaderSize: SelectHeaderSize.EXTRA_SMALL, selectedElement: this.buildSelectedElement(pageSize), allElements: this.buildSelectElements(pageSizeOptions), onChange: this.onGroupByChange, "data-testid": 'paginationComponent_paginationSelect', ChildrenWrapper: PaginationChildrenWrapper }),
            this.props.totalRowCount && (React.createElement(React.Fragment, null,
                React.createElement(PaginationLabel, { text: this.props.ofText }),
                React.createElement(PaginationLabel, { text: this.props.totalRowCount.toString() }))),
            React.createElement(ButtonsWrapper, null,
                previousPageButton,
                nextPageButton)));
    }
}
const PaginationWrapper = styled.div `
  position: relative;
  padding: 5px 11px 5px 7px;
  display: flex;
  flex-direction: row;
  
  line-height: 28px;
  
  border-top: 1px solid ${props => props.theme.colors.silverLight};
  background-color: ${props => props.theme.colors.silverLighter};
`;
const PaginationSelect = styled(Select) `
  margin-right: 3px;
`;
const PaginationLabel = styled(Label) `
  margin-right: 3px;
  font-size: 13px;
  
  color: ${props => props.theme.colors.tertiaryText};
`;
const ButtonsWrapper = styled.div `
  height: 28px;
  display: inline-block;
  
  margin-left: auto;
`;
// isDisabled property should not be passed into the Image component,
// so we have to extract it using the following convention:
const PaginationButton = styled(({ isDisabled, ...rest }) => React.createElement(Image, { ...rest })) `
  display: inline-block;

  width: 28px;
  height: 28px;

  background: ${props => props.theme.colors.white};
  opacity: ${props => props.isDisabled && '0'};

  border-radius: 3px;
  border: 1px solid ${props => props.theme.colors.silverLight};

  margin-right: 1px;
  
  cursor: pointer;

  img {
    height: 16px;
    margin: 6px 0;

    opacity: 1;
    background: none;
    border: none;
  }
`;
const PaginationChildrenWrapper = styled(DefaultChildrenWrapper) `
    bottom: 42px;
`;
//# sourceMappingURL=PaginationComponent.js.map